import type { FormTourConfig } from './formTour';

const CONFIGURE_CANDIDATE_EMAIL_START_PATH = '/candidates';

export const configureCandidateEmailTour = {
  taskId: 'configure_candidate_email',
  storageKey: 'onboarding-configure-candidate-email-tour-step',
  startPath: CONFIGURE_CANDIDATE_EMAIL_START_PATH,
  activePathPrefixes: ['/candidates', '/candidate'],
  navStepCount: 1,
  completeTaskViaBackend: true,
  overlineLabel: 'Configure Candidate Email Tour',
  steps: [
    {
      title: 'Open Candidates',
      description: 'Click Candidates in the sidebar to open the candidates list.',
      targetTestIds: ['@sidebar-candidates'],
    },
    {
      title: 'Open a candidate',
      description: 'Click a candidate in the list to open their profile.',
      targetTestIds: ['@candidates-table', '@candidate-detail'],
      highlightTargetTestIds: ['@candidates-table'],
      disableBack: true,
    },
    {
      title: 'Open the email editor',
      description: 'Click the pencil next to Emails to open the editor.',
      targetTestIds: ['@candidate-emails-field', '@candidate-emails-edit'],
      highlightTargetTestIds: ['@candidate-emails-field'],
      contextTargetTestIds: ['@candidate-emails-editor'],
      disableBack: true,
    },
    {
      title: 'Save the email',
      description: 'Add or update an email address, then click outside the editor to save.',
      targetTestIds: ['@candidate-emails-editor'],
      highlightTargetTestIds: ['@candidate-emails-editor'],
      contextTargetTestIds: ['@candidate-emails-editor'],
      panelPlacement: 'above',
      disableBack: true,
    },
  ],
  stepActions: {
    0: {
      type: 'wait-for-target',
      advanceTo: 1,
      waitForTargetTestIds: ['@candidates-table'],
    },
    1: {
      type: 'wait-for-target',
      advanceTo: 2,
      waitForTargetTestIds: ['@candidate-detail'],
      autoAdvanceWhenTargetSatisfied: true,
    },
    2: {
      type: 'wait-for-target',
      advanceTo: 3,
      waitForTargetTestIds: ['@candidate-emails-editor'],
    },
    3: {
      type: 'complete-when-target-absent',
      waitForAbsentTestIds: ['@candidate-emails-editor'],
    },
  },
} as const satisfies FormTourConfig;
